import { FormElement } from '@uplift/types';
import { ButtonStyleRadio, ButtonStyleRadioGroup } from '@uplift/ui-v2';
import React, { useMemo } from 'react';
import { useStyles } from './styles';

type SingleSelectItemLabelProps = {
  text: string;
  hintText: string;
  boldText: boolean;
};

const SingleSelectItemLabel = ({ text, hintText, boldText }: SingleSelectItemLabelProps) => {
  if (boldText && hintText) {
    return <><strong>{text}</strong>&nbsp; {hintText}</>;
  }

  if (boldText) {
    return <strong>{text}</strong>;
  }

  return <span>{text}</span>;
};

export type SingleSelectProps = {
  element: FormElement;
  onClick: (value: string | null) => void;
};

export const SingleSelect: React.VFC<SingleSelectProps> = ({ element, onClick }) => {
  const { classes } = useStyles();

  const handleChange = (name: string, value: string | null) => {
    onClick?.(value);
  };

  const hasHint = useMemo(
    () => element.formElementAnswers.findIndex(a => a.hintText) !== -1,
    [ element ]
  );

  const answers = useMemo(
    () => element.formElementAnswers.sort((a, b) => a.order - b.order),
    [ element.formElementAnswers ]
  );

  return (
    <ButtonStyleRadioGroup
      name={element.formElementId}
      color="secondary"
      label=""
      className={classes.buttonRadios}
      handleChange={handleChange}
    >
      {answers.map(answer => (
        <ButtonStyleRadio
          key={answer.formElementAnswerId}
          value={answer.formElementAnswerId}
        >
          <SingleSelectItemLabel
            text={answer.answerText}
            hintText={answer.hintText ?? ''}
            boldText={hasHint}
          />
        </ButtonStyleRadio>
      ))}
    </ButtonStyleRadioGroup>
  );
};
